// Objects that only a system admin may create, edit or delete (owner 2026-10-11) — the mirror of
// backend/services/admin_only_objects.py. The server is the gate; this only hides what would be refused.
//
// Why: a user renamed the work type "התקנה (טכנאי מכירה)" to "קוויק" and the install option vanished
// from every Closed Won close (the picker, the sales calculation and the TechApp match it by name).

export const ADMIN_ONLY_OBJECTS = ['worktype'];
export const ADMIN_ONLY_HIDDEN_BUTTONS = ['edit', 'delete', 'clone', 'new'];
export const ADMIN_ONLY_OBJECT_MESSAGE = 'רק מנהל מערכת יכול ליצור, לערוך או למחוק סוגי עבודה';

export const isAdminOnlyObject = (objectName) =>
  ADMIN_ONLY_OBJECTS.includes(String(objectName || '').trim().toLowerCase());
